module.exports = __webpack_public_path__ + "static/media/Pin_Job_TireInstall.074cba7e.svg";